import { create } from 'zustand'

interface UiState {
  sidebarOpen: boolean
  theme: 'light' | 'dark' | 'system'
  commandPaletteOpen: boolean

  toggleSidebar: () => void
  setSidebarOpen: (open: boolean) => void
  closeSidebar: () => void
  setTheme: (theme: 'light' | 'dark' | 'system') => void
  toggleCommandPalette: () => void
  setCommandPaletteOpen: (open: boolean) => void
}

// Initial sidebar state — desktop (>=768px) open by default, mobile closed.
// SSR-safe: window check.
const getInitialSidebarOpen = (): boolean => {
  if (typeof window === 'undefined') return true
  return window.matchMedia('(min-width: 768px)').matches
}

export const useUiStore = create<UiState>((set) => ({
  sidebarOpen: getInitialSidebarOpen(),
  theme: 'system',
  commandPaletteOpen: false,

  toggleSidebar: () => set((state) => ({ sidebarOpen: !state.sidebarOpen })),
  setSidebarOpen: (open) => set({ sidebarOpen: open }),
  closeSidebar: () => set({ sidebarOpen: false }),
  setTheme: (theme) => set({ theme }),
  toggleCommandPalette: () => set((state) => ({ commandPaletteOpen: !state.commandPaletteOpen })),
  setCommandPaletteOpen: (open) => set({ commandPaletteOpen: open }),
}))
